import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BeneficioProporcionalDiferidoComponent } from '../beneficio-proporcional-diferido/beneficio-proporcional-diferido.component';
import { PcdDemosntrativoComponent } from '../pcd-demosntrativo/pcd-demosntrativo.component';
import { PcdDashboardComponent } from '../pcd-dashboard/pcd-dashboard.component';
import { PbbPainelControleGerencialComponent } from '../pbb-painel-controle-gerencial/pbb-painel-controle-gerencial.component';
import { PcdInformacoesComponent } from '../pcd-informacoes/pcd-informacoes.component';

const planoRoutes = [
    { path: 'plano/bpdConsulta', component: BeneficioProporcionalDiferidoComponent },
    { path: 'plano/pcdDemonstrativo', component: PcdDemosntrativoComponent },
    { path: 'plano/pcdDashboard', component: PcdDashboardComponent },
    { path: 'plano/pbbDashboard', component: PbbPainelControleGerencialComponent },
    { path: 'plano/pcdinformacoes', component: PcdInformacoesComponent },
];

@NgModule({
    imports: [RouterModule.forChild(planoRoutes)],
    exports: [RouterModule]
})
export class PlanosRoutingModule {


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/router/planos.router.ts